const zh = {
  common: {
    lang: '语言',
    back: '返回',
    next: '下一步',
    submit: '提交',
    confirm: '确认',
    cancel: '取消',
    confirmInfo: '确认信息',
    updatePwd: '修改密码',
    logout: '退出登录',
    emptyText: '暂无数据',
    imgFormatVerify: '只能上传 .jpg/.png/.jpeg 格式图片!',
    imgSizeVerify: '上传图片大小不能超过 200KB!',
    loading: '加载中...',
  },
  login: {
    title: '登录',
    titleBtn: '登  录',
    or: '或',
    scanSuccess: '扫码成功！',
    codeExpired: '该二维码已过期',
    retryText: '请重新获取',
    retry: '重新获取',
    scanWechat: '扫描关注微信公众号并登录',
    forgetPassword: '重置密码',
    password: '密码',
    phoneOrEmail: '你的Email地址',
    loginLoading: '登录中',
    accountTip: '请填写Email地址',
    loginAccount: '帐号密码登录',
    pwdTip: '请填写密码',
    pwdErrorTip: '密码错误，请检查Email地址或密码',
    accountNotExistTip: '用户不存在，请检查Email地址或密码',
    firstLoginText: '首次登录系统，请使用账号密码登录',
    agreementAgree: '我已阅读并接受协议内容。',
    agreementTip: '请阅读并同意协议内容',
    agreementContent: `<p><strong>2023-2024年度AP考试</strong></p>
    <p><strong>个人数据隐私披露和同意书</strong></p>
    <p>
      在
      Prometric，保护您的个人数据和信息，并确保您了解这些信息的处理方式和原因，对我们而言至关重要。作为您的考试主办方的数据处理者，Prometric
      仅会出于注册考试、安排考试日程、管理考试以及处理考试成绩的目的来处理您的个人信息。未经您的许可，Prometric
      绝不会将您的个人信息用于任何其他目的。您的个人信息（包括您的考试成绩）都将提供给您的考试主办方，用于提供分数、认证或其他与考试相关服务的目的。完整的
      Prometric 隐私权政策可在以下网址找到： www.prometric.com/zh-hans/yinsizhengce
    </p>
    <p>
      我们可能会雇用其他公司和个人代表我们履行职能。可查阅个人数据和信息的我方员工、代理和承包商需按照 Prometric
      隐私权政策保护信息，对信息保密并维护数据主体的权利，而且我们要求第三方确保像 Prometric
      对其员工要求的那样保护隐私权，并遵守包括适用的数据保护法在内的相关规定。我们不会将信息传送给非经相应合约关系担任
      Prometric 代理或代表的第三方。
    </p>
    <p>
      Prometric LLC
      公司的总部位于美国。美国国内及国际考生的个人资料将收集自或传送至美国处理并储存，但我们位于世界其他地区的许多关联公司和数据处理器都可能会存取这些数据，以促进第一段所述之目的。「国际考生」系指永久居住在美国境外，且不具备美国护照的考生或员工。无论个人所在位置或个人资料原始收集地或最终处理或储存地为何，Prometric
      均会保护个人资料之隐私与安全。您（即数据当事人及／或考生）的个人资料将在经过收集与处理后，透过您的申请或与考试主办方签约应考、透过
      Prometric 进行注册与安排，以及点击下方的「登录」明确表示同意时，进行授权。
    </p>
    <p>
      为了从欧洲经济区传输个人数据，Prometric 维持欧盟-美国 隐私保护和瑞士-美国
      隐私保护认证。您可以在正常工作时间内通过联系您的考试主办方随时请求访问、更正、删除、移植、限制个人数据或反对对个人数据的处理，或者进行查询、请求、投诉或撤销相关的同意书。您还可以通过
      www.prometric.com/datasubjectrequests 直接向 Prometric 提交数据主题访问请求。
    </p>
    <p><strong>视频和音频监控</strong></p>
    <p>
      Prometric 在其考试中心网络中部署数字视频录制系统（DVR 或
      CCTV）。在适用法律允许的情况下，这包括在接待室/寄存间、监考区/安全登记处和考试实验室区域内安装音频录制系统。为了保护高风险专项考试内容的安全性、考试交付体验的完整性，阻止欺诈和欺骗，防止盗窃和偷盗，以及为了员工和公司财产的安全，这样做很有必要。录制的材料将严格限于授权人员接触，并按照当地适用法律允许的期限保留。
    </p>
    <p>
      在我们的远程监考平台（ProProctor）上，Prometric
      收集由登记流程开始并于考试全程录制的录像视频，包括录音在内。有时，这将包括您的办公桌和工作区。我们将对您和您的工作区、办公桌以及您的工作区内的声音进行实时监控，并在考试进行期间记取与录下，以保护高利害关系专项考试内容的安全性、考试交付体验的完整性，阻止欺诈和欺骗并防止盗窃和偷盗。ProProctor
      的录音与录像将严格限于授权人员接触，并保留三十（30）天，或适用法律允许的期限（即合法证据）。
    </p>
    <p>
      收集、传送、处理、使用和储存您的个人资料，是管理您的考试之必要流程。若不同意收集、传送、处理、使用和储存您的个人资料，请务必联络您的考试主办方。
    </p>
    <p>
      继续注册与安排今天的考试，即表示您知道、赞成及同意在您的考试过程中进行录音、录像，且在远程监考的考试方面，包括录制您的桌面和个人作业空间的声音与影像。您知道并同意，在考试过程中会进行实时监控及记录，且知道并同意在考试签到过程或考试过程中没有隐私权，并明确放弃主张您的隐私权或侵犯您的隐私权之所有相关求偿。
    </p>
    <p>
      <strong>
        本人确认，本人已年满 18
        周岁，或本人是数据主体和/或考生的家长或监护人，且本人有权就个人数据收集和处理相关事宜进行以下选择。
      </strong>
    </p>
    <p>
      <strong>
        我确认，通过下面的“登录”，即表示我明确同意按照我的考试主办方的要求收集和处理我的个人数据，这可能包括视频和音频录制内容和/或生物识别数据以及考试结果，除非我以书面形式向我的考试主办方或者通过
        www.prometric.com/datasubjectrequests 肯定地撤回同意书，否则此类同意将保持有效。
      </strong>
    </p>
    <p>&nbsp;</p>`,
    loginClickTips: '很抱歉，您的点击操作太频繁，请休息3秒后再试哦！',
    register: '没有帐号？立即注册',
    loginBottomTips1: '社会考生报名参加AP考试。请先查看',
    loginBottomTips2: '报名须知',
    loginBottomTips2Split: '、',
    loginBottomTips3: 'AP学生指导手册',
    loginBottomTips4: '缴费指导',
    loginBottomTips5: '的相关内容后，再',
    loginBottomTips6: '创建登录账号',
    loginBottomTips7: '以便开始报名。',
    loginBottomTips8: '请注意：如无AP Profile账号，请点击',
    loginBottomTips9: '此处',
    loginBottomTips10: '先创建账号。',
    loginBottomTipsAnd: '及',
    loginBottomTipsWX: '如已关联微信，点击扫码登录',
  },
  homeIndex: {
    createWorkOrder: '新建工单',
    edit: '编辑',
    bindWX: '绑定微信',
    print: '打印准考证',
    createEnroll: '新建报名',
    save: '保存',
    save400ErrorTips: '个人信息保存失败，请重试。如有问题，请联系报名中心获取帮助。',
    cancel: '取消',
    seeLogs: '查看更改日志',
    school: '学校',
    examCenter: '考点城市',
    lastNameCHS: '证件 姓（中文）',
    lastNameCHSPlaceHolder: '请输入证件 姓（中文）',
    lastNameCHSFormatPlaceHolder: '请输入汉字。',
    firstNameCHS: '证件 名（中文）',
    firstNameCHSPlaceHolder: '请输入证件 名（中文）',
    lastNameEN: '证件 姓（拼音）',
    lastNameENPlaceHolder: '请输入证件 姓（拼音）',
    lastNameENFormatPlaceHolder: '请输入拼写名字，首字母请大写。',
    firtNameEN: '证件 名（拼音）',
    firtNameENPlaceHolder: '请输入证件 名（拼音）',
    government_id_type: '证件类型',
    government_id_typePlaceHolder: '请选择证件类型',
    government_id: '证件号码',
    government_idPlaceHolder: '请输入证件号码',
    government_idFormatPlaceHolder: '证件号码格式错误。',
    government_idCorrectSexPlaceHolder: '身份证号与性别不匹配，请检查',
    government_idCorrectBirthPlaceHolder: '身份证号与出生日期不匹配，请检查',
    cardTitle1: 'AP学生信息',
    cardTitle2: '证件照',
    cardTitle3: '报名缴费资格',
    cardTitle4: '考试报名',
    cardTitle5: '工单',
    sex: '性别',
    sexPlaceHolder: '请选择性别',
    male: '男',
    female: '女',
    birthday: '出生日期',
    birthdayPlaceHolder: '请选择出生日期',
    emailAddr: 'Email地址',
    phone1: '手机号码 1',
    phone2: '手机号码 2',
    phone1PlaceHolder: '请输入手机号码 1',
    phone2PlaceHolder: '请输入手机号码 2',
    phoneCorrectPlaceHolder: '请正确填写手机号',
    address1: '地址第1行（拼音）',
    address2: '地址第2行（拼音）',
    address3: '地址第3行（拼音）',
    addressPlaceHolder: '请输入地址',
    addressFormatPlaceHolder: '只能使用字母和数字以及字符 . , - / #。',
    postal_code: '邮编',
    postal_codePlaceHolder: '请输入邮编',
    postal_codeFormatPlaceHolder: '输入中国大陆地区6位数字邮编。',
    province: '直辖市/省/特区',
    provincePlaceHolder: '请选择直辖市/省/特区',
    city: '市/区/县',
    cityPlaceHolder: '请选择市/区/县',
    grade: '年级',
    gradePlaceHolder: '请选择年级',
    languagePre: '语言偏好',
    languagePrePlaceHolder: '请选择语言偏好',
    parent_education_level: '父母/监护人1学历水平',
    parent_education_levelPlaceHolder: '请选择学历水平',
    parent2_education_level: '父母/监护人2学历水平',
    photo: '证件照',
    photoPlaceHolder: '请上传证件照',
    photo_qualified: '照片是否合格',
    photo_status: '照片状态',
    eligibility_id: '报考缴费资格ID',
    registration_link: '报考缴费链接',
    roster_name: '名称',
    roster_date: '考试日期',
    roster_order_status: '付款状态',
    roster_confirmation: '缴费确认号 #',
    roster_enroll_status: '报名状态',
    orders_id: '工单编号',
    orders_subject: '主题',
    orders_resolution: '处理结果',
    orders_process: '工单状态',
    orders_date_created: '创建日期',
    orders_last_modified: '修改日期',
    modifyTips: '修改成功！',
    modifyErrorTips1: '保存失败，证件号码已存在。',
    msgText: '工单回复',
    msgTips: '您有新的新的工单回复请前往查看~',
    signResultTitle: '报名结果',
    signSubject: '科目',
    signSubjectStatus: '状态',
    signSubjectDesc: '说明',
    birthdayCorrectPlaceHolder: '出生日期需要符合报考要求。',
  },
  createWorkOrderModal: {
    title: '创建工单',
    subject: '主题',
    desc: '问题描述',
    attachment: '附件',
    attachmentPasteHint: '支持 Ctrl+V 粘贴图片或文件',
    attachmentUploadTip: '点击上传',
    attachmentCountHint: '{current}/{max}',
    attachmentMaxCount: '单个工单最多上传 5 个附件',
    attachmentMaxTotalSize: '单个工单附件总大小不能超过 50MB',
    attachmentMaxSingleSize: '单个附件大小不能超过 10MB',
    attachmentMaxImageSize: '单个图片大小不能超过 5MB',
    attachmentFormatError: '仅支持 jpg、jpeg、png、webp、pdf、doc、docx、xls、xlsx、pptx、txt、zip 格式',
    attachmentForbiddenFormat: '不允许上传 exe、bat、cmd、sh、js、html、php、jar 等格式文件',
    attachmentUploadingBlock: '附件正在上传，请稍后再提交',
    attachmentUploadRetry: '上传失败，点击重试',
    attachmentRetryShort: '重试',
    attachmentUploading: '上传中',
    attachmentPreviewTitle: '文件预览',
    attachmentPreviewError: '文件预览失败，请下载后查看',
    attachmentPreviewUnsupported: '该格式暂不支持在线预览',
    subjectPlaceholder: '请填写主题',
    descPlaceholder: '请填写问题描述',
    createTips: '工单创建成功！',
    replyTips: '回复成功！',
    user: '用户',
    customerService: '客服',
    bottomTips1: '工单处理并非实时对话，请等候客服回复',
    bottomTips2: '如需立即获得帮助，请',
    bottomLink: '联系我们',
  },
  modifyLogModal: {
    title: '更改日志',
    tips: `此模块中的已审计字段所有者ID, Email地址, 地址第2行（拼音）, 地址第3行（拼音）, 手机号码 2, 地址第1行（拼音）, 出生日期,
    证件号码, 证件 名（拼音）, 证件 名（中文）, 证件 姓（拼音）, 证件 姓（中文）, 手机号码 1, 邮编, 父母/监护人2学历水平,
    证件类型, 年级, 父母/监护人1学历水平, 语言偏好, 直辖市/省/特区, 市/区/县, 性别, 证件照`,
    field: '字段',
    old_value: '旧值',
    new_value: '新值',
    changed_by: '创建人',
    change_date: '日期',
  },
  modifyPwd: {
    title: '修改密码',
    newPwd: '新密码',
    newPwdPlaceholder: '请填写新密码',
    tips: '密码修改成功！',
  },
  forgetPwd: {
    title: '重置密码',
    newPwd: '新密码',
    newPwdPlaceholder: '请填写新密码',
    newPwdFormatPlaceholder: '只能使用字母和数字组合，最少8位',
    confirmPwd: '确认密码',
    confirmPwdPlaceholder: '请填写确认密码',
    confirmPwdFormatPlaceholder: '请确保两次密码输入一致',
    email: 'Email地址',
    emailPlaceholeder: '请填写Email地址',
    code: '验证码',
    getCode: '获取验证码',
    codePlaceholder: '请填写验证码',
    tips: '密码重置成功！',
    expiredTips: '验证码已过期',
    invalidTips: '无效的验证码',
    accountTips: '帐号不存在！',
    againTips: '获取验证码频繁，稍后再试',
  },
  register: {
    title: '用户注册',
    subtitleBold: '本用户注册仅限于【社会考生】报名使用。',
    subtitle1: '请访问AP China网站',
    subtitle1Split: '了解本年度的AP考试报名政策、流程和指导。',
    subtitle2: '所在学校开设了AP课程的学生是通过学校统一创建账号，学生请勿自行创建登录账号。',
    subtitle3: '请填写以下信息完成账号创建，提交后个人信息将不可修改。',
    sectionAccount: '账号信息',
    sectionProfile: '个人信息',
    sectionPassword: '设置密码',
    hasAccount: '已有账号？',
    toLogin: '返回登录',
    email: '邮箱',
    emailPlaceholder: '请输入邮箱，该邮箱需和AP Profile账号一致',
    authCode: '验证码',
    authCodePlaceholder: '请输入验证码',
    getAuthCode: '获取验证码',
    authCodeTips: '验证码发送成功！',
    authCodeErrTips1: '验证码发送失败',
    authCodeErrTips2: '获取验证码频繁，稍后再试',
    authCodeErrTips3: '邮箱已被注册，请勿重复创建。',
    testCenter: '考点城市',
    testCenterPlaceholder: '请选择要参加考试的城市，用户注册后将不能修改。',
    school: '就读高中',
    schoolPlaceholder: '请输入就读高中或学籍所在高中名称',
    pwd: '密码',
    pwdPlaceholder: '请输入密码',
    confirmPwd: '确认密码',
    confirmPwdPlaceholder: '请再次输入密码',
    pwdValidTips1: '请输入密码',
    pwdValidTips2: '密码长度不能少于8位',
    pwdValidTips3: '密码必须包含字母和数字',
    pwdValidTips4: '两次输入的密码不一致',
    emailValidTips1: '请输入邮箱',
    emailValidTips2: '请输入正确的邮箱格式',
    testCenterValidTips: '请选择考点城市',
    registerTips: '注册成功！',
    registerErrTips1: '验证码过期',
    registerErrTips2: '验证码无效',
    lastName: '证件 姓（拼音）',
    lastNamePlaceholder: '请输入证件 姓（拼音），需和AP Profile账号一致',
    firstName: '证件 名（拼音）',
    firstNamePlaceholder: '请输入证件 名（拼音），需和AP Profile账号一致',
    grade: '年级',
    gradePlaceholder: '请选择年级',
    btn: '创建账号',
    confirmInfoTips: '个人信息提交后不可修改，确认无误后再提交',
  },
  selectSubject: {
    title: '选择考试科目',
    examName: '科目名称',
    testDate: '考试日期',
    tips1: '请参考',
    tips2: '报名须知',
    tips3: '了解本年度AP考试报名的相关信息。',
    tips4: '学生在同一年只能报考AP微积分AB或AP微积分BC其中一门，不能同时报考两门。',
    selectTips: '请至少选择一门科目',
    selectTips2: '请选择AP微积分AB或AP微积分BC其中一门',
  },
}
export default zh
